module.exports = __webpack_public_path__ + "/images/logo-app-appstore.a1a9e9c.svg";